export const ACTION_CONTACT_SENT_MESSAGE_STATUS = 'CONTACT_SENT_MESSAGE_STATUS'